import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "shield"
const ShieldIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 1.5S16.5 4.5 21 6C21 21 12 22.5 12 22.5 11.997 22.5 3 20.998 3 6 8.249 4.5 11.999 1.501 12 1.5M12.058 3.313C11.605 3.627 10.987 4.035 10.229 4.48 8.787 5.328 6.821 6.33 4.518 7.1 4.724 13.563 6.742 16.996 8.56 18.814 9.536 19.79 10.5 20.35 11.203 20.662 11.54 20.81 11.814 20.9 12 20.956 12.186 20.902 12.461 20.81 12.797 20.661 13.499 20.349 14.464 19.79 15.44 18.814 17.262 16.992 19.285 13.546 19.482 7.05 17.476 6.29 15.555 5.316 14.084 4.5 13.257 4.039 12.56 3.623 12.058 3.313" />
        </svg>
      }
    </span>
  )
}
export default ShieldIcon
